import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ChevronLeft = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.429 3.14574C10.2027 2.93859 9.85128 2.95413 9.64412 3.18047L5.58294 7.61767C5.32148 7.90333 5.32721 8.34306 5.59602 8.62182L9.65403 12.8301C9.86701 13.0509 10.2187 13.0573 10.4396 12.8444C10.6604 12.6314 10.6668 12.2797 10.4538 12.0588L6.6422 8.10603L10.4638 3.93065C10.6709 3.70431 10.6554 3.3529 10.429 3.14574Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ChevronLeft;
